import { FF } from 'modules/feature-flags';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useLayouts } from '../Viewer/StudyLoader/useLayouts';
import { generateViewportId, getViewportGrid } from '../Viewer/viewerUtils';

import { useVirtualMonitorSplitToggle } from 'hooks/useVirtualMonitorSplitToggle';

import { useRecoilState, useRecoilValue } from 'recoil';
import { viewportUpIdSelector, viewportUpIds } from '../Viewer/viewerState';
import { WithApolloContext } from 'modules/Apollo/types';

export const useRenderedViewportIds = ({ context }: WithApolloContext): Array<string> => {
  const viewportIds = useRecoilValue(viewportUpIds);
  const [virtualMonitorSplit] = useVirtualMonitorSplitToggle({ context });
  const { layoutsForCase: layouts } = useLayouts({ context });
  const [minColumnsToEnableMultipleExpansionAreas] = useSplitFlag(
    FF.MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS,
    (value) => Number(value ?? 2)
  );

  return Object.entries(layouts).flatMap(([windowId, layout]: [any, any]) => {
    return Array.from(
      new Set(
        getViewportGrid(
          viewportIds[windowId] ?? [],
          (row, col) => generateViewportId(windowId, row, col),
          layout,
          virtualMonitorSplit,
          minColumnsToEnableMultipleExpansionAreas
        ).flat()
      )
    );
  });
};

export const useRenderedViewportIdsForWindow = ({
  windowId,
  context,
}: { windowId: string } & WithApolloContext): Array<string> => {
  const [viewportIds] = useRecoilState(viewportUpIdSelector(windowId));
  const [virtualMonitorSplit] = useVirtualMonitorSplitToggle({ context });
  const { layoutForWindow: layout } = useLayouts({ context });
  const [minColumnsToEnableMultipleExpansionAreas] = useSplitFlag(
    FF.MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS,
    (value) => Number(value ?? 2)
  );

  return Array.from(
    new Set(
      getViewportGrid(
        viewportIds,
        (row, col) => generateViewportId(windowId, row, col),
        layout ?? [0, 0],
        virtualMonitorSplit,
        minColumnsToEnableMultipleExpansionAreas
      ).flat()
    )
  );
};
